var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5187 2.00063H3.47625C2.6625 2.00063 2 2.64625 2 3.44125V20.5562C2 21.3531 2.6625 22 3.47625 22H20.52C21.3356 22 22 21.3531 22 20.5562V3.44125C22 2.64625 21.3356 2.00063 20.5187 2.00063Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96563 9.49812H7.93751V19.0419H4.96563V9.49812ZM6.44938 4.74812C7.39751 4.74812 8.16813 5.51875 8.16813 6.46687C8.16813 7.415 7.39751 8.1875 6.45001 8.1875C5.99392 8.18651 5.55678 8.00493 5.23422 7.68248C4.91165 7.36004 4.72992 6.92297 4.72876 6.46687C4.72876 6.24101 4.77328 6.01735 4.85977 5.8087C4.94626 5.60005 5.07303 5.4105 5.23283 5.25087C5.39263 5.09125 5.58233 4.96468 5.79107 4.87842C5.99982 4.79215 6.22352 4.74788 6.44938 4.74812ZM9.79313 9.49812H12.6381V10.8025H12.6775C13.0738 10.0525 14.0413 9.26125 15.49 9.26125C18.4938 9.26125 19.0481 11.2381 19.0481 13.8075V19.0425H16.0838V14.4C16.0838 13.2937 16.0638 11.8687 14.5425 11.8687C12.9988 11.8687 12.7613 13.075 12.7613 14.3187V19.04H9.79751V9.49625L9.79313 9.49812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.58193af93b268d8c4b9af4780c8189f9.svg";
export { ForwardRef as ReactComponent };